import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

/**
 * One warehouse zone: what it is called, what it is for, and where its chain continues.
 *
 * Read on its own rather than picked out of `useWarehouseZones`, so the detail page does not
 * depend on the list having been opened first — and so an edit invalidating `warehouse-zone`
 * reprints the label beside it.
 */
export function useWarehouseZone(warehouseZoneId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["warehouse-zone", warehouseZoneId],
		queryFn: async () => {
			const response = await client.stock["warehouse-zones"][":warehouseZoneId"].$get({
				param: { warehouseZoneId },
			});
			const data = await responseHandler(response);
			return data.warehouseZone;
		},
	});

	/** Return */
	return { ...query, warehouseZone: query.data ?? null };
}
